(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-marks-info-choices.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-marks-info-choices.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo,
  useContext = _React.useContext;
const selectTipsinfoSupport = svs.components.tipsen.engine.selectors.engineSelectors.selectTipsinfoSupport;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const selectOutcomeInfoChoise = svs.components.tipsen.selectors.selectOutcomeInfoChoise;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const useFilteredOutcomeInfoChoises = () => {
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const outcomeInfoChoice = useSelector(state => selectOutcomeInfoChoise(state, pageType));
  const tipsinfoSupport = useSelector(state => selectTipsinfoSupport(state, pageType));
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  const isResult = currentEngine.outcomes.eventTypeId === EventTypeId.RESULT;
  return useMemo(() => {
    const outcomeInfoChoises = [];
    const outcomeLabel = isGoalCount || isResult ? 'Antal mål' : '1X2';
    const outcomeInfoChoisesOptions = {
      [TipsinfoTypes.OutcomeLabel]: outcomeLabel,
      [TipsinfoTypes.SvenskaFolket]: 'Svenska folket (%)'
    };
    const outcomeInfoChoisesKeys = Object.keys(outcomeInfoChoisesOptions);
    for (const key of outcomeInfoChoisesKeys) {
      if (tipsinfoSupport[key]) {
        var _outcomeInfoChoisesOp;
        outcomeInfoChoises.push({
          isSelected: outcomeInfoChoice.display === key,
          key,
          title: (_outcomeInfoChoisesOp = outcomeInfoChoisesOptions[key]) !== null && _outcomeInfoChoisesOp !== void 0 ? _outcomeInfoChoisesOp : ''
        });
      }
    }
    return outcomeInfoChoises;
  }, [isGoalCount, isResult, outcomeInfoChoice.display, tipsinfoSupport]);
};
setGlobal('svs.components.tipsen.tipsinfo.useFilteredOutcomeInfoChoises', useFilteredOutcomeInfoChoises);

 })(window);